module.exports = __webpack_public_path__ + "img/WelcomeToCORUCC.579950d0.jpg";